<template>
  <div class="chart-dialog">
    <el-dialog title="校外成绩对比" :visible.sync="externalChartDialogShow" width="50%" :before-close="dialogClose">
      <!-- 柱状图 -->
      <div id="myChart" ref="chart" style="height: 400px; width: 100%; margin: 0 auto"></div>
      <div style="text-align: center" v-hasPermi="'sc:extramuralgrade:export'">
        <el-button type="primary" round @click="exportExternalGrades">导出excel</el-button>
        <el-button type="primary" round @click="changeChart">切换视图</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  props: [
    "externalChartDialogShow",
    "scoreGradeContrastData",
    "courseFullList",
  ],
  data() {
    return {
      myChart: null,
      course: "", // 班级维度对比选择的科目
      isRadar: true
    };
  },
  mounted() {
    setTimeout(() => {
      // 初始化图
      this.initChart(JSON.parse(JSON.stringify(this.scoreGradeContrastData)));
    }, 200);
  },
  beforeDestroy() {
    this.clearChart();
  },
  methods: {
    changeChart() {
      // console.log(this.scoreGradeContrastData);
      this.clearChart();
      if (this.isRadar) {
        this.barGraphInit();
      } else {
        this.noClassExamInit(this.scoreGradeContrastData);
      }
      this.isRadar = !this.isRadar;
    },
    barGraphInit() {
      this.myChart = echarts.init(document.getElementById("myChart"));

      let data = JSON.parse(JSON.stringify(this.scoreGradeContrastData));

      let o;
      let categories = [];
      let seriesData = [];

      data.forEach((v, i) => {
        categories.push(v.gradeName);
        v.avgScoreList.forEach((item, index) => {
          if (!seriesData[index]) {
            seriesData[index] = {
              name: item.courseName,
              type: 'bar',
              data: [],
            };
          }
          seriesData[index].data.push(item.courseAvgScore);
        });
      });

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "#fff",
          borderColor: "#000",
          borderWidth: 1,
          textStyle: {
            color: "#000",
            fontSize: 12,
          },
        },
        legend: {
          data: seriesData.map(item => item.name),
        },
        xAxis: {
          type: 'category',
          data: categories,
        },
        yAxis: {
          type: 'value',
        },
        series: seriesData,
      };

      this.myChart.setOption(option);

      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
    exportExternalGrades() {
      let action = `${baseURL}${this.$url.scoreGradeExtramuralContrastExcelPC}?examInfoId=${this.scoreGradeContrastData[0].examInfoId}&gradeId=${this.scoreGradeContrastData[0].gradeId}&outsideSchoolSign=${this.scoreGradeContrastData[0].outsideSchoolSign}`;
      window.open(action);
    },
    // 销毁图例
    clearChart() {
      if (
        this.myChart != null &&
        this.myChart != undefined &&
        this.myChart != ""
      ) {
        this.myChart.dispose();
      }
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:externalChartDialogShow", false);
      this.clearChart();
    },
    initChart() {
      this.noClassExamInit(this.scoreGradeContrastData);
    },
    noClassExamInit(data) {
      this.myChart = echarts.init(document.getElementById("myChart"));
      let copyData = JSON.parse(JSON.stringify(data));
      // console.log("copyData:", copyData);
      data.push({
        gradeName: copyData[0].outsideSchoolSign,
        avgScoreList: copyData[0].avgScoreList.map((item) => {
          item.courseAvgScore = item.outAvgScore;
          return item;
        }),
      });
      // console.log("data:", data);

      // 初始化变量
      let o;
      let arr1 = [];
      let arr2 = [];
      let legendData = [];

      // 遍历数据
      data.forEach((v, i) => {
        // 如果图表类型是外部表现对比
        // 将班级名称添加到图例数据数组
        legendData.push(v.gradeName);
        // 将平均分列表和班级名称添加到 arr2 数组
        arr2.push({ value: v.avgScoreList, name: v.gradeName });

        // 遍历平均分列表
        v.avgScoreList.forEach((item, index) => {
          // 构建对象 o，包括文本和最大值
          o = {
            text: item.courseName,
          };
          // 如果 arr1 数组中不存在与 o 相同文本的对象，则将 o 添加到 arr1 数组
          if (!arr1.find((aItem) => aItem.text === o.text)) {
            arr1.push(o);
          }
        });
      });

      arr2.forEach((item) => {
        item.value = item.value.map((vItem) => vItem.courseAvgScore);
      });

      // console.log(legendData, arr1, arr2);

      const option = {
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "#fff", // 悬浮框背景色
          borderColor: "#000", // 悬浮框边框颜色
          borderWidth: 1, // 悬浮框边框宽度
          textStyle: {
            // 悬浮框文字样式
            color: "#000",
            fontSize: 12,
          },
        },
        legend: {
          data: legendData,
        },
        radar: {
          indicator: arr1,
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            data: arr2,
          },
        ],
      };

      // 指定图表的配置项和数据
      this.myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./gradeExternalChartDialog.scss";
</style>